import { observer } from 'mobx-react-lite';
import cn from 'classnames';

import './GreenDot.styl';

interface Props {
    isVisible: boolean;
    className?: string;
}

export const GreenDot = observer(({ isVisible = false, className }: Props) => {
    return isVisible ? <div className={cn('green-dot', className)}></div> : null;
});
